import { useState, ReactNode } from "react";
import { Col, Form, Row, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  SuggestionWidget,
  BlockContentControls,
  ModalCommon,
  ButtonCommon,
  ProductsForm,
} from "../../../common";
import { IProduct } from "../../../common/types";
import "./ProductRegistration.css";
import { FormattedMessage } from "react-intl";

const ProductRegistration = (props: any) => {
  const [hiddenTitle, setHiddenaTitle] = useState(true);
  const [hiddenActions, setHiddenaActions] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [modalStep, setModalStep] = useState(1);
  const [isSaving, setIsSaving] = useState(false);

  const navigate = useNavigate();
  const [formProducts, setFormProducts] = useState<IProduct[]>([]);

  const onShowModal = () => {
    setIsSaving(true); // Set loading state to true
    setShowModal(true);

    // Simulate async process (e.g., saving data)
    setTimeout(() => {
      setIsSaving(false); // Set loading state to false after process
      setModalStep(2); // Move to the next modal step
    }, 3000); // Simulate 3 seconds delay
  };

  const onHideModal = () => {
    setShowModal(false);
  };

  const onOkModal = () => {
    setModalStep(2);
  };

  const ModalContent = () => {
    return (
      <Form className="not-found-items-modal-container">
        <div className="associate-succes-modal">
          <img
            className="associate-succes-modal-save"
            src="/img/productcreated.png"
            alt="Succes"
            width={320}
          />
          <p className="associate-succes-modal-p">
            <FormattedMessage id="product-registration-widget-product-created" />
          </p>
        </div>
      </Form>
    );
  };

  const onClickCancelar = () => {
    navigate(-1);
  };

  const handlerChangeForm = (Elements: IProduct[]) => {
    console.log("HANDLER CHANGE FORM", Elements);
    setFormProducts(Elements);
  };

  const getProducts = (FormProducts: IProduct[] | []) => {
    let aProducts: IProduct[] = new Array<IProduct>();
    let newProduct: IProduct;

    try {
      if (FormProducts && FormProducts.length > 0) {
        aProducts = [...formProducts];
      } else {
        newProduct = {
          Id: 1,
          Name: "",
          Code: "",
          Variants: new Array<string>(),
          BodyArea: { Id: 4, Name: "" },
          Gender: { Id: 3, Name: "" },
          Fit: { Id: 1, Name: "" },
          Categories: new Array<string>(),
          SizeGuide: null,
          Sizes: null,
          PositionRow: 0,
        };

        aProducts.push(newProduct);
      }
    } catch (error) {
      console.log(error);
    }

    return aProducts;
  };

  return (
    <div className="crud-container">
      <div className="notfound-products-help-widgets">
        <Row>
          <Col className="notfound-products-help-widget">
            <SuggestionWidget
              title={
                <FormattedMessage
                  id="product-registration-widget-title"
                  defaultMessage="Importante"
                />
              }
              description={
                <FormattedMessage
                  id="product-registration-widget-description"
                  defaultMessage="Completar el <b>Modelo</b> es obligatorio y debe coincidir con el que utilizan en la página de e-commerce. \n\n  Si no cuentas con códigos de modelo, debes crearlo."
                  values={{
                    b: (...chunks: ReactNode[]) => <b>{chunks}</b>,
                    br: <br />,
                  }}
                />
              }
            />
          </Col>
          <Col className="notfound-products-help-widget">
            <SuggestionWidget
              title={
                <FormattedMessage
                  id="product-registration-widget-title"
                  defaultMessage="Importante"
                />
              }
              description={
                <FormattedMessage
                  id="product-registration-widget-description-two"
                  defaultMessage="Al crear un Modelo, puedes utilizar las <b>primeras cifras de los SKUs</b> (como se muestra en el ejemplo.) Luego, cuando asocies una guía de talle al Modelo, se asignará a todos los SKUS automáticamente"
                  values={{
                    b: (...chunks: ReactNode[]) => <b>{chunks}</b>,
                    br: <br />,
                  }}
                />
              }
            />
          </Col>
        </Row>
      </div>
      <div>
        <Row>
          <Col>
            <BlockContentControls
              paddingX={3}
              children={
                <ProductsForm
                  canUpdload={props.canUpdload || false}
                  Elements={getProducts(formProducts)}
                  SuscribeChanges={(e: IProduct[]) => handlerChangeForm(e)}
                />
              }
            />
          </Col>
        </Row>
      </div>
      <div>
        <Row className="">
          <Col className="crud-button">
            <ButtonCommon
              label={
                <FormattedMessage
                  id="ready-size-Cancelar"
                  // defaultMessage="Cancelar"
                />
              }
              isOutline={true}
              eventClick={onClickCancelar}
            />
          </Col>
          <Col className="crud-button-save d-flex align-items-center">
            <ButtonCommon
              label={
                <FormattedMessage
                  id="ready-size-Guardar"
                  defaultMessage="Guardar"
                />
              }
              isOutline={false}
              eventClick={onShowModal}
              disabled={isSaving} // Disable the button while saving
            />
            {isSaving && (
              <div className="ms-3">
                <Spinner animation="border" role="status" size="sm">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </div>
            )}
          </Col>
          <Col>
            <ModalCommon
              Title="product-registration-modal-title"
              buttonSuccessTitle={"Crear"}
              Show={showModal}
              OnModalClose={onHideModal}
              OnModalOk={onOkModal}
              Content={ModalContent()}
              HiddenTitle={true}
              HiddenActions={true}
            />
          </Col>
        </Row>
        <br />
      </div>
    </div>
  );
};

export default ProductRegistration;
